import { render, staticRenderFns } from "./AnthropometricsSummary.vue?vue&type=template&id=578013e0"
import script from "./AnthropometricsSummary.vue?vue&type=script&lang=js"
export * from "./AnthropometricsSummary.vue?vue&type=script&lang=js"
import style0 from "./AnthropometricsSummary.vue?vue&type=style&index=0&id=578013e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports